(() => {
  const start = () => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('deferred-media').forEach(media => {
      const template = media.querySelector('template');
      if (!template) return;
      const frame = template.content.querySelector('iframe');
      const video = template.content.querySelector('video');
      if (frame) {
        const url = new URL(frame.src);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set(url.hostname.includes('youtube') ? 'mute' : 'muted', '1');
        url.searchParams.set('playsinline', '1');
        frame.src = url.toString();
        frame.loading = 'lazy';
      }
      if (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.autoplay = true;
        video.playsInline = true;
      }
    });
    const first = gallery.querySelector('deferred-media');
    if (!first || first.hasAttribute('loaded')) return;
    const slide = first.closest('.product__media-item');
    let ready = false;
    let visible = false;
    let queued = false;
    let observer;
    let changes;
    first.dataset.bpAutoplayStage = 'waiting';
    const isActive = () => !slide || slide.classList.contains('is-active');
    const launch = () => {
      queued = false;
      if (!ready || !visible || document.hidden || !isActive()) return;
      if (first.hasAttribute('loaded')) {
        cleanup();
        return;
      }
      const frame = first.querySelector('template')?.content.querySelector('iframe');
      if (frame) frame.loading = 'eager';
      first.loadContent(false);
      first.dataset.bpAutoplayStage = 'started';
      performance.mark('blaspo-autoplay-start');
      cleanup();
    };
    const schedule = () => {
      if (queued || !ready || !visible || document.hidden || !isActive()) return;
      queued = true;
      if ('requestIdleCallback' in window) requestIdleCallback(launch, { timeout: 1200 });
      else setTimeout(launch, 0);
    };
    const cleanup = () => {
      observer?.disconnect();
      changes?.disconnect();
      document.removeEventListener('visibilitychange', schedule);
    };
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.1 });
      observer.observe(first);
    } else {
      visible = true;
    }
    if (slide) {
      changes = new MutationObserver(schedule);
      changes.observe(slide, { attributes: true, attributeFilter: ['class'] });
    }
    const poster = first.querySelector('.deferred-media__poster img');
    const decoded = poster?.decode ? poster.decode().catch(() => {}) : Promise.resolve();
    Promise.race([decoded, new Promise(resolve => setTimeout(resolve, 4500))]).then(() => {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        ready = true;
        schedule();
      }));
    });
  };
  const initialize = () => customElements.whenDefined('deferred-media').then(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

